export default {
  viewBox: "0 0 25 24",
  html: "<path fill=\"currentColor\" d=\"M4.68 11h16v2h-16zm12-5-4 4-4-4h3V2h2v4zm-8 12 4-4 4 4h-3v4h-2v-4z\"/>"
};